import apiClient from './client';

export const getAllComplexFilters = async () => {
  console.log("📡 Fetching system complex filters...");
  const response = await apiClient.get('/complex-filters');
  console.log("✅ Received complex filters:", response.data);
  return response.data;
};